<ng-container>
  <mat-toolbar class="notScrollable" color="accent" *ngIf="getShowtable()">

    <div *ngIf="!isSmallDevice" class="tiTex">{{ 'pages.zeitverwaltung.title' | translate}}</div>
    <button mat-icon-button class="printIcon" (click)="openAuswertungen(0)">
    <mat-icon  matTooltip="Drucken">print</mat-icon>
    </button>
    <mat-icon [hidden]="isSmallDevice" matTooltip="Filtern" *ngIf="!isFilterActive" (click)="openFilter()"  class="searchIcon">search</mat-icon>
    <mat-icon [hidden]="isSmallDevice" matTooltip="Gefiltert" *ngIf="isFilterActive" (click)="deleteFilter()"  class="searchIcon">manage_search</mat-icon>

    <button [hidden]="isSmallDevice" matTooltip="Serie Verrechnen" class="actionIcon" mat-icon-button [matMenuTriggerFor]="actionMenu">
      <mat-icon>monetization_on</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
      <button [hidden]="isSmallDevice"
              *ngIf="($zeit | async) as Zeit" (click)="alleVerrechnen(Zeit)" mat-menu-item >{{ 'pages.zeitverwaltung.actions.alleVerrechnet' | translate }}</button>
    </mat-menu>
  </mat-toolbar>
  <mat-menu #printMenu="matMenu">
    <button *ngIf="(showPrint | async)" mat-menu-item (click)="openAuswertungen(0)" >{{ 'pages.zeitverwaltung.zeitDrucken' | translate}}</button>

  </mat-menu>
  <!-- Suche nach projekt Name und Datum einzeln oder gemeinsam -->
  <form  [formGroup]="filterSucheForm" autocomplete=off>

    <div class="farbeUndRahmenSuchfeld">
      <img class="zeiterfassungLogo" *ngIf="isSmallDevice"  src="//local.curion.ch/myDay/assets/Icone_Zeiterfassung48orange.ico">

      <mat-form-field class="datumFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.filter.start' | translate }}</mat-label>
        <input
          (ngModelChange)="search()"
          matInput
          [matDatepicker]="picker"
          formControlName="datumVon"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="datumFeld" appearance="outline" color="accent">
        <mat-label>{{ 'pages.projektverwaltung.filter.ende' | translate }}</mat-label>
        <input
          (ngModelChange)="search()"
          matInput

          [matDatepicker]="endepicker"
          formControlName="datumBis"
        /><!-- [placeholder]="'pages.projektverwaltung.filter.ende' | translate" -->
        <mat-datepicker-toggle matSuffix [for]="endepicker" ></mat-datepicker-toggle>
        <mat-datepicker #endepicker></mat-datepicker>
      </mat-form-field>
      <mat-checkbox formControlName="zuverrechnen"
                    class="checkboxAbstand"
                    (change)="search()"
                    *ngIf="!isSmallDevice"
      >
        {{ 'pages.zeitverwaltung.offen' | translate }}</mat-checkbox>
    </div>
  </form>
  <form *ngIf="!isSmallDevice"  [formGroup]="userForm" autocomplete=off>
    <mat-form-field class="select-user-container" appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.benutzer' | translate }}</mat-label>
      <mat-select [disabled]="!(showChangeUser | async)" (ngModelChange)="setNewUserSession($event)" formControlName="user">
        <mat-option *ngFor="let user of ($user | async)" [value]="user.id">
          {{user.name + " " + user.vorname + " " + user.plz + " " + user.ort}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <div class="add-button-container">
    <button
      matTooltip="Zeit Hinzufügen"
      *ngIf="(showAdd | async)"
      mat-mini-fab
            color="primary"
            class="pluscolor"
            (click)="newAddtime()">
      <mat-icon>add</mat-icon>
    </button>

  </div>
  <div>
    <div id="viewer"></div>
  </div>
  <div *ngIf="getShowtable()" class="page-content">


    <app-zeiterfassung-table
      [zeit]="$zeit | async"
      [saldo]="$saldo | async"
      [showFunctionMenu]="functionMenuEnabled"
      (edit)="editZeit($event)"
      (delete)="deleteZeit($event)"
      (openAuswertungen)="openAuswertungen($event)"
      (saldoReport)="saldoReport($event)"
      (openFerienReport)="openFerienReport()"
      (loadReport)="loadReport($event.showBenutzername, $event.showZwischensummen, $event.showDetails, $event.showAllUsers, $event.filterDatumStart, $event.filterDatumEnde, $event.zeitAuswahl, $event.spesenAuswahl, $event.showSeparat)"
    >
    </app-zeiterfassung-table>

  </div>
<!--  <div *ngIf="getShowtable()" class="untenRand"></div> -->
</ng-container>
<button hidden="true" id="timerButton" mat-button (click)="timer()">Add Time</button>
